import React from 'react';
import { observer } from 'mobx-react-lite';
import { Stopwatch } from '../../stores/timer-store';
import { timerStore } from '../../stores/timer-store';
import './stopwatch-card.scss';

interface StopwatchCardProps {
  stopwatch: Stopwatch;
}

export const StopwatchCard: React.FC<StopwatchCardProps> = observer(({ stopwatch }) => {
  const handleStart = () => {
    timerStore.startStopwatch(stopwatch.id);
  };

  const handlePause = () => {
    timerStore.pauseStopwatch(stopwatch.id);
  };

  const handleReset = () => {
    timerStore.resetStopwatch(stopwatch.id);
  };

  const handleLap = () => {
    timerStore.lapStopwatch(stopwatch.id);
  };

  const handleDelete = () => {
    timerStore.deleteStopwatch(stopwatch.id);
  };

  return (
    <div className="stopwatch-card">
      <div className="stopwatch-card__header">
        <h3 className="stopwatch-card__name">{stopwatch.name}</h3>
        <button 
          onClick={handleDelete}
          className="stopwatch-card__delete"
          title="Delete stopwatch"
        >
          ✕
        </button>
      </div>

      <div className="stopwatch-card__display">
        <div className="stopwatch-card__time">
          {timerStore.formatTime(stopwatch.elapsed)}
        </div>
      </div>

      <div className="stopwatch-card__controls">
        {!stopwatch.isRunning ? (
          <button 
            onClick={handleStart}
            className="stopwatch-card__button stopwatch-card__button--start"
          >
            {stopwatch.isPaused ? 'Resume' : 'Start'}
          </button>
        ) : (
          <button 
            onClick={handlePause}
            className="stopwatch-card__button stopwatch-card__button--pause"
          >
            Pause
          </button>
        )}

        {stopwatch.isRunning && (
          <button 
            onClick={handleLap}
            className="stopwatch-card__button stopwatch-card__button--lap"
          >
            Lap
          </button>
        )}

        <button 
          onClick={handleReset}
          className="stopwatch-card__button stopwatch-card__button--reset"
        >
          Reset
        </button>
      </div>

      {stopwatch.laps.length > 0 && (
        <div className="stopwatch-card__laps">
          <h4 className="stopwatch-card__laps-title">Laps</h4>
          <div className="stopwatch-card__laps-list">
            {stopwatch.laps.map((lapTime, index) => (
              <div key={index} className="stopwatch-card__lap">
                <span className="stopwatch-card__lap-number">
                  Lap {index + 1}
                </span>
                <span className="stopwatch-card__lap-time">
                  {timerStore.formatTime(lapTime)}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
});
